export const questionnaireArea = {
  EvaluationTherapy: 1,
  Transportation: 2,
  TecnicalAssistance: 3,
};
